/**
 * Class VerticalTabs
 */
class VerticalTabs {
	block: HTMLElement;
	tabs: NodeListOf<HTMLElement>;
	bellows: NodeListOf<HTMLElement>;

	constructor(element: HTMLElement) {
		this.block = element;
		this.tabs = element.querySelectorAll('.block-vertical-tabs__tabs button');
		this.bellows = element.querySelectorAll(
			'.block-vertical-tabs__content .block-vertical-tab'
		);

		this.init();
		this.addListeners();
	}

	init() {
		this.tabs.forEach((el, i) => {
			const expanded = i === 0 ? 'true' : 'false';
			const focusable = i === 0 ? '0' : '-1';
			el.setAttribute('aria-expanded', expanded);
			el.setAttribute('tabindex', focusable);
		});
		this.bellows.forEach((el, i) => {
			const expanded = i === 0 ? 'true' : 'false';
			const focusable = i === 0 ? '0' : '-1';
			el.setAttribute('data-expanded', expanded);
			el.setAttribute('tabindex', focusable);

			const tabContent = el.querySelector('.block-vertical-tab__content');
			if (tabContent) {
				tabContent.setAttribute('tabindex', focusable);
			}
		});
	}

	addListeners() {
		this.tabs.forEach((el) => {
			el.addEventListener('click', (e: MouseEvent) => {
				this.handleClick(e);
			});
		});
	}

	/**
	 * Handle tab click
	 *
	 * @param {MouseEvent} e
	 */
	handleClick(e: MouseEvent) {
		const clicked = e.target as HTMLElement;
		let bellow: string | null;
		bellow = null;

		if (clicked.hasAttribute('aria-controls')) {
			bellow = clicked.getAttribute('aria-controls');
		}
		this.tabs.forEach((el) => {
			const tabID = el.getAttribute('aria-controls');
			el.setAttribute('aria-expanded', bellow === tabID ? 'true' : 'false');
			el.setAttribute('tabindex', bellow === tabID ? '0' : '-1');
		});
		this.bellows.forEach((el) => {
			const tabID = el.getAttribute('id');
			el.setAttribute('data-expanded', bellow === tabID ? 'true' : 'false');
			el.setAttribute('tabindex', bellow === tabID ? '0' : '-1');

			const tabContent = el.querySelector('.block-vertical-tab__content');
			if (tabContent) {
				if (el.getAttribute('data-expanded') === 'true') {
					tabContent.setAttribute('tabindex', '0');
					(tabContent as HTMLElement).focus();
				} else {
					tabContent.setAttribute('tabindex', '-1');
					(tabContent as HTMLElement).blur();
				}
			}
		});
	}
}

const blockVerticalTabs = document.querySelectorAll<HTMLElement>('.block-vertical-tabs');
blockVerticalTabs.forEach((el) => {
	new VerticalTabs(el);
});
